import { Table } from 'legacy/lut/library/list'
import { useMemo } from 'react'

import { Static } from 'core-components/types'
import { Crud } from 'core/types'
import { P360Currency } from 'partner360/models/P360Currency'

import { IMdfActivity } from '../../model/types'
import { getSummaryColumns } from '../mdfActivitiesTable/helpers/getSummaryColumns'

import styles from './MdfActivitiesSummaryTable.module.scss'

interface IMdfActivitiesSummaryTableProps {
  activities: IMdfActivity[]
  currency: string
}

export const MdfActivitiesSummaryTable = ({
  activities,
  currency,
}: IMdfActivitiesSummaryTableProps) => {
  const source = useMemo(
    () =>
      new Crud<IMdfActivity>({
        fetcher: new Static(activities),
        keyField: 'entryId',
        defaultPaging: { page: 0, pageSize: activities.length || 1 },
      }),
    [activities]
  )
  const columns = useMemo(
    () => getSummaryColumns({ isUsd: currency === P360Currency.USD, isActivityClickable: false }),
    [currency]
  )

  return (
    <div className={styles.root}>
      <Table<IMdfActivity> header source={source} columns={columns} />
    </div>
  )
}
